import type { Task, TaskListItem } from "@myapp/contract";

type TaskLike = Pick<Task | TaskListItem, "status" | "schedule">;

/**
 * Mirrors the guard in `DeleteTaskUseCase`: work that already happened is a record, not a plan, so
 * a completed or already-started Aufgabe cannot be removed. The API answers those with 409
 * `TASK_DELETE_FORBIDDEN`, and a row that offered the button would only produce an error the user
 * can do nothing about.
 *
 * An unscheduled task has no `schedule` at all and is therefore deletable — nothing has started.
 */
export const canDeleteTask = (task: TaskLike): boolean =>
  task.status !== "COMPLETED" && task.schedule?.actualWorkStartsAt == null;
